/**
 * 接口文档
 * http://api-doc-sl.inshopline.com/#/project/80/feature%2F20210907_v1.0.0/interface/55a2b08a0e3dff7b8b3c55d7a82d35ae
 */
export default {
  /** 查询商品列表 */
  list: '/api/spu-sku-group/search',
}
